import React, { Component } from 'react';
import SvgIcon from 'react-icons-kit';
import {print} from 'react-icons-kit/fa/print';
import {stethoscope} from 'react-icons-kit/fa/stethoscope';
import {iosSpeedometer} from 'react-icons-kit/ionicons/iosSpeedometer';
import {ic_event_note} from 'react-icons-kit/md/ic_event_note';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';
import {history} from 'react-icons-kit/icomoon/history';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
import { translate } from 'react-i18next';
import ModalVitalSigns from './components/ModalVitalSigns';
import ModalBiometrics from './components/ModalBiometrics';
import ModalPrintLabel from '../generics/ModalPrintLabel';
import swal from 'sweetalert';
import LabelModal from '../distribution/samples/LabelModal';
import ModalNotes from '../results_donation/components/ModalNotes';

import IconBio from '../../assets/icons/biometric';
import IconHC from '../../assets/icons/HC';  
import IconSV from '../../assets/icons/sv';  

import WaitingModal from '../generics/WaitingModal';
import ModalPrint from './components/ModalPrint';

var Config = require('../../config');

class Toolbar extends Component{
	constructor(props, context) {
		super(props, context);
		this.enableOptions = this.enableOptions.bind(this);
		this.onLabelClick = this.onLabelClick.bind(this);
		this.onPrintClick = this.onPrintClick.bind(this);
		this.selectLabel = this.selectLabel.bind(this);
		this.openModalNotes = this.openModalNotes.bind(this);
		this.updateDonationNotesID = this.updateDonationNotesID.bind(this);
		this.printConcent = this.printConcent.bind(this);
		this.printIdentification = this.printIdentification.bind(this);
		

		this.state = {
			disableBar: true,
			offers_id:"",
			donor_id:"",
			task_vital_signs:JSON.parse(sessionStorage.getItem("task_vital_signs")),
		    task_biometrics:JSON.parse(sessionStorage.getItem("task_biometrics")),
		    task_clinic_history:JSON.parse(sessionStorage.getItem("task_clinic_history")),
		    preview_print:{},
		    
		}
	}

	componentDidMount() {
		this.props.onRef(this);

		this.setState({
			task_vital_signs:JSON.parse(sessionStorage.getItem("task_vital_signs")),
		    task_biometrics:JSON.parse(sessionStorage.getItem("task_biometrics")),
		    task_clinic_history:JSON.parse(sessionStorage.getItem("task_clinic_history"))
		});


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}


		//Criterio funcional,cambiar lugar de colecta
      fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print',{ 
          method: 'get',
          headers: new Headers({
             'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
             'Accept': 'application/json',
             'Content-Type': 'application/json',
          })
      })
      .then(response => response.json())
      .then(response => {
        this.setState({
            preview_print: response
          });
      })
	}

	componentWillUnmount() {
	    this.props.onRef(null)
	}

	openModalVitalSigns(e){
		e.preventDefault();
		this.modal_vital_signs.handleShow(this.state.offers_id,this.state.donor_id);
	}

	openModalBiometrics(e){
		e.preventDefault();
		this.modal_biometrics.handleShow(this.state.offers_id, this.state.donor_id);
	}

	openModalHC(e){
	    e.preventDefault();
	    this.props.history.push("/clinic_history/"+this.state.offers_id+'/'+this.state.donor_id);
	}

	enableOptions(offers_id,donor_id){
		this.setState({
		    disableBar: false,
		    offers_id:offers_id,
		    donor_id:donor_id
		});
	}

	onLabelClick(e){
		e.preventDefault();
		
		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type=label_extraction&extraction_type=',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ninguna etiqueta para el área de registro", 'error');
			}else{
				this.waiting_modal.handleShow('Imprimiendo...');
				
				var obj ={};
				obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
				obj.id = this.state.offers_id;
				obj.file_type = "label_register";
				obj.nEtiqueta = [];
				fetch(Config.default.apiGateway.URL+'labelsEditor', {
					method : 'post',
					body:JSON.stringify(obj),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.blob();
					}else{
		              res.text().then(function(result) {
		                swal('¡Error', result, 'error');
		                return;
		              });
		            }
				})
				.then(response => {
					if(response !== undefined){
						if(this.state.preview_print.value === "NO"){
						//PREVIEW
							var fileURL = URL.createObjectURL(response);
			       			window.open(fileURL);
						}else{
							//PRINTER
							var reader = new FileReader();
							reader.readAsDataURL(response); 
							reader.onloadend = ()=>{
								var base64data = reader.result;  
								var aux = base64data.split(',');
								this.props.socket.send('{"Operacion":"print", "Type":"label_register", "File": "'+aux[1]+'"}');
							}
						}

			       		this.setState({ show: false});
		       		}
				})
			}
		})
		
	}

	onPrintClick(e, type = 'area_register'){
		e.preventDefault();

		if(this.state.preview_print.value === 'YES'){
			
			fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type='+type+'&extraction_type=',{ 
				method: 'get',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(res => {
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(result) {
	                swal('¡Error!', result, 'error');
	              });
	            }})
			.then(async response => {
				if(response.res === 0){
					swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
				}else{
					this.waiting_modal.handleShow('Imprimiendo...');
					
					var obj ={};
					obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
					obj.id = this.state.offers_id;
					obj.file_type = type;
					obj.nEtiqueta = [0];

					var type = await this.props.getDocumentType(obj.file_type);

					var document;
					if(type.print_type === 'template'){
						document = await this.props.printDocumentTemplate(obj, type.print_automatically);
					}else if(type.print_type === 'external'){
						document = await this.props.printDocumentExternal(obj, type.print_automatically);
					}

					if(document !== undefined){
						this.waiting_modal.handleClose();
					}else{
						this.waiting_modal.handleClose();
					}
				
				}
			})
		}else{
			this.modal_print.handleShow(this.state.offers_id,this.state.preview_print);
		}
	}

	async printConcent(e,item){
		e.preventDefault();
		this.props.waiting.handleShow('Imprimiendo...');
        
      	var obj ={};
      	obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = item.offers_id;
		
      	obj.file_type = item.extraction_name==="AFÉRESIS" || item.extraction_name === "AFERESIS" ? "informed_consent_af"
                       : item.extraction_name==="SANGRE TOTAL" || item.extraction_name === "SANGRE_TOTAL" ? "informed_consent_st"
                       : item.extraction_name === "CÉLULAS" ? "informed_consent_cl" : "";
      	obj.nEtiqueta = [0];

      	var type = await this.props.getDocumentType(obj.file_type);
      	if(type !== undefined){
			var document;
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}
		}

		this.props.waiting.handleClose();
				

	}

	async printIdentification(e,id){
		e.preventDefault();
		this.props.waiting.handleShow('Imprimiendo...');
        
		  var obj ={};
		  console.log(id)
      	obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
	
      	obj.file_type = "donor_identification_card";
      	obj.nEtiqueta = [0];

    var type = await this.props.getDocumentType(obj.file_type);
    if(type !== undefined){
    	var document;
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}

			if(document !== undefined){
				this.props.waiting.handleClose();
			}else{
				this.props.waiting.handleClose();
			}	
    }else{
    	this.props.waiting.handleClose();
    }


			

	}

	selectLabel(e){
		e.preventDefault();
	
		if(this.props.state.new_type === 'new'){
			this.label_modal.handleShow(this.props.state.donation_selected);
		}else{
			this.label_modal.handleShow(this.props.state.donation_selected, 'label_second_sample');	
		}
		
	}

	updateDonationNotesID(id){
		this.props.updateNoteId(id);
		//this.setState({donation_notes_id:id});
	}

	openModalNotes(e){
		e.preventDefault();

		if(this.props.state.donation_selected !== undefined){
			this.modal_notes.handleShow(
				this.props.state.donation_selected.donation_notes_id, 
				this.props.state.donation_selected.donation_id, 
				this.props.state.donation_selected.sample_id,
				this.props.state.donation_selected.offers_id,
				this.props.state.donor_id,
				'sample_register'
			);
		}else{
			this.modal_notes.handleShow(
				'',
				this.props.match.params.donation_id,
				'',
				this.props.state.offer_id,
				this.props.state.donor_id,
				'register'
			)
		}
	}


	render(){
		const { t } = this.props;
		var submenu = this.props.match.path.replace('/', '');

		return(
			<div className="col-xs-12" style={
				submenu !== 'samples/new' && submenu.indexOf('second_samples/edit') === -1?
					{margin:"0px",textAlign:"center",fontSize:"9px",padding:"0px",marginLeft: "26%"}
				: 	{margin:"0px",textAlign:"center",fontSize:".85em",padding:"0px",paddingLeft: "45%"}
			}>
				{this.props.task_vital_signs.read === true && 
					submenu !== 'samples/new' && 
					submenu.indexOf('petition_samples/new') === -1 &&
					submenu.indexOf('second_samples/edit') === -1 ? 
					<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
						<button className="toolIcon" onClick={(e) => this.openModalVitalSigns(e)} disabled={this.state.disableBar || !this.props.task_vital_signs.read}>
							{/*<SvgIcon size={40} icon={stethoscope} />*/}
							<IconSV width={40} title="Signo Vitales" fill={"var(--color-no-data-icon)"}  />
							<div className="col-xs-12">
								<span>{t('toolbar.vital_signs')}</span>
							</div>
						</button>
					</div>
				: null
				}

				{this.props.task_biometrics.read === true && 
					submenu !== 'samples/new' && submenu.indexOf('petition_samples/new') === -1 &&
					submenu.indexOf('second_samples/edit') === -1? 
					<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
						<button className="toolIcon" onClick={(e) => this.openModalBiometrics(e)} disabled={this.state.disableBar || !this.props.task_biometrics.read}>
							<IconBio width={40} title="Biométricos" fill={"var(--color-no-data-icon)"}  />
							{/*<SvgIcon size={40} icon={iosSpeedometer} />*/}
							<span>{t('toolbar.biometric')}</span>
						</button>
					</div>
				
				: null
				}

				{this.props.task_clinic_history.read === true && 
					submenu !== 'samples/new' && submenu.indexOf('petition_samples/new') === -1 &&
					submenu.indexOf('second_samples/edit') === -1? 
					<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
						<button className="toolIcon" onClick={(e) => this.openModalHC(e)} disabled={this.state.disableBar || !this.props.task_clinic_history.read}>
							{/*<SvgIcon size={40} icon={ic_event_note} />*/}
							<IconHC width={40} title="Historia Clinica" fill={"var(--color-no-data-icon)"}  />
							<div className="col-xs-12">
								<span>{t('toolbar.clinic_history')}</span>
							</div>
						</button>
					</div>
				
				: null
				}
				<div className={"col-xs-12 col-md-1"} style={{padding:"0"}}>
					<button className="toolIcon" disabled={this.state.disableBar} 
						onClick={submenu !== 'samples/new' && submenu.indexOf('second_samples/edit') === -1 ?
								 this.onLabelClick : this.selectLabel}>
						<SvgIcon size={40} icon={ic_local_offer} />
						<div className="col-xs-12">
							<span>{t('toolbar.labels')}</span>
						</div>
					</button>
				</div>
				{submenu.indexOf('petition_samples/new') === -1 || submenu.indexOf('second_samples/edit') === -1 ?
					<div>
						{/*submenu !== 'samples/new' && submenu.indexOf('second_samples/edit') === -1 ?
							<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
								<button className="toolIcon" disabled={this.state.disableBar}>
									<SvgIcon size={40} icon={history} />
									<div className="col-xs-12">
										<span>{t('toolbar.history_review')}</span>
									</div>
								</button>
							</div>
						:null}
						{submenu !== 'samples/new' && submenu.indexOf('second_samples/edit') === -1?
							<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
								<button className="toolIcon" disabled={this.state.disableBar}>
									<SvgIcon size={40} icon={history} />
									<div className="col-xs-12">
										<span>{t('toolbar.history_review')}</span>
									</div>
								</button>
							</div>
						:null*/}
						{submenu !== 'samples/new' && submenu.indexOf('second_samples/edit') === -1?
							<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
								<button className="toolIcon" disabled={this.state.disableBar} 
									onClick={submenu.indexOf('offers/') !== -1 || submenu.indexOf('offers/') !== -1 ?
										(e)=>this.printConcent(e, {
											offers_id:this.props.state.offer_id, 
											extraction_name:this.props.state.stats.extraction_type
										}) 
									: this.onPrintClick}>
									<SvgIcon size={40} icon={print} />
									<div className="col-xs-12">
										<span>
											{submenu.indexOf('offers/') !== -1 || submenu.indexOf('offers') !== -1 ?
												t('toolbar.print_con')
											: t('toolbar.print1')}
										</span>
									</div>
								</button>
							</div>
						:submenu === 'samples/new' || submenu.indexOf('second_samples/edit') !== -1 ?
							<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
								<button className="toolIcon" disabled={this.state.disableBar} 
									onClick={(e)=>this.props.printSecondSample(e)}>
									<SvgIcon size={40} icon={print} />
									<div className="col-xs-12">
										<span>
											{t('toolbar.print1')}
										</span>
									</div>
								</button>
							</div>
						:null}
						<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
							{submenu !== 'samples/new' && submenu.indexOf('second_samples/edit') === -1}
							<button className="toolIcon" disabled={this.state.disableBar}
								style={this.props.state.flag_notes ? {color:'green'} : {}}
								onClick={(e)=>this.openModalNotes(e)}>
								<SvgIcon size={40} icon={pencilSquareO} />
								<div className="col-xs-12">
									<span>{t('toolbar.save_notes')}</span>
								</div>
							</button>
						</div>
						{(submenu.indexOf('offers/') !== -1 || submenu.indexOf('offers') !== -1) &&
							<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
								<button className="toolIcon" disabled={this.state.disableBar}
									onClick={(e)=>this.printIdentification(e, this.props.state.offer_id)}>
									<SvgIcon size={40} icon={print} />
									<div className="col-xs-12">
										<span>Ficha identificación</span>
									</div>
								</button>
							</div>
						}
					</div>
				:null}
					
				<ModalVitalSigns {...this.props} onRef={ref => (this.modal_vital_signs = ref)} />
				<ModalBiometrics {...this.props} onRef={ref => (this.modal_biometrics = ref)} />
				<ModalPrintLabel {...this.props} onRef={ref => (this.modal_print_label = ref)}/>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalPrint {...this.props} onRef={ref => (this.modal_print = ref)} socket={this.props.socket}/>
				<LabelModal {...this.props} onRef={ref => (this.label_modal = ref)} socket={this.props.socket}/>
				<ModalNotes {...this.props} onRef={ref => (this.modal_notes = ref)} updateNotesID={this.updateDonationNotesID}/>
			</div>
		)
	}
}

export default translate('translations')(Toolbar);